// import React from 'react';
import 'devextreme/data/odata/store';
import ODataStore from 'devextreme/data/odata/store';
import DataSource from 'devextreme/data/data_source';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { FaBox, FaBoxOpen, FaYoutube } from "react-icons/fa";
import { AiFillYoutube } from "react-icons/ai";
import {container } from 'devextreme-react/button';
import ArrayStore from 'devextreme/data/array_store';
// import 'bootstrap/dist/css/bootstrap.min.css';
import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';
import 'whatwg-fetch';
//import Url from '../../Service';
import React, { useState,useEffect } from 'react';
import { useForm } from "react-hook-form";
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
 import { BasePath, Url } from '../../Service';
 import striped from 'react-bootstrap/Table';
//import { BasePath, url } from '../../Service';
import play from './image/play.png';
// import 'devextreme/dist/css/dx.light.css';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Grouping, GroupPanel, scrollX, HeaderFilter, SearchPanel, Scrolling, MasterDetail,
} from 'devextreme-react/data-grid';
import { SideNavInnerToolbar } from '../../layouts';

let url = '';
let data ='';
debugger;
let testvalue = { Url };
let testingtwo ='role=admin'
url = testvalue.Url + 'api/Video/types?types=';
data =url&testingtwo;
export default function Video() {
  debugger;
  const { types } = useParams();
  debugger;

  const dataSource = {
    store: {
      type: 'odata',
      key: 'idk',
      keytype: 'Int32',
      version: 4,
      url: url + types
    },
  };
 const[button,setButton]=useState('');
 const data = window.location.href;
  let val= data.split('/');

  let test=val[5].slice(0,16);
    useEffect(()=>{
  
      if (test=='QkFDS0VORA==&rol') {
        // setButton(prevState => ({ ...prevState, button: newButton }));
        setButton(<Button className='btn btn-ptimary mb-2' onClick={() => onclickpop()}>Add New</Button>);
           }
      else {
        // setButton(<Button className='btn btn-ptimary mb-2' visible={false}>Add New</Button>);
       }
  
  },[test]);
  let [labelText, setlabelText] = useState('');
    
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

   //Display the Row data into popup for editing condition
   const [GetList, SetList] = useState([]);
   const onEditing = (data) => {
       debugger;
       setidkpopup(data.idk);
       SetList(data);
       settype(data.type);
       setName(data.name);
       setcategiory(data.categiory);
       setpath(data.path);
       setdescription(data.description);
       setlabelText('Edit videos');
       handleShow();
   }

   const onclickpop = () => {
    debugger;
    setlabelText('Add videos');
    handleShow(true);
}

  const reload = () => window.location.reload();

  //Popup show and hide 
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [idkpopup, setidkpopup] = useState(0);
  const [type, settype] = useState('');
  const [name, setName] = useState('');
  const [categiory, setcategiory] = useState('');
  const [path, setpath] = useState('');
  const [description, setdescription] = useState('');


  const onSubmit = () => {
    debugger;
    //setlabelText('add videos');
    //console.log(inputRef.current.value);
    if (labelText == "Add videos") {
        fetch(testvalue.Url +'api/Video/AddVideos', {
            method: 'POST',
            body: JSON.stringify({
                // Add parameters here
                type: type,
                name: name,
                categiory: categiory,
                path: path,
                description: description
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                reload();
                handleShow();
                // Handle data
            })
            .catch((err) => {
                console.log(err.message);
            });
    }
    else {
        fetch(testvalue.Url +'api/Video/UpdateVideos', {
            method: 'PUT',
            headers: {
                'Accept': 'applucation/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({

                // Add parameters here
                name: name,
                categiory: categiory,
                path: path,
                description: description,
                idk: idkpopup,
                type: type,

            }),
        })

            .then((response) => response.json())
            .then((data) => {
                debugger;
                reload();
                handleShow();
                // Handle data
            })
            .catch((err) => {
                console.log(err.message);
            });
    }
}
     
  return (
    <React.Fragment>
       {/* <Button className='btn btn-ptimary mb-2' onClick={handleShow}  >Add New</Button>  */}
         {button}
         <Modal id="modalpop" show={show} onExit={reload} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {/* <Form.Label id="idtype" name="Add Videos">   <sup className='required-mrk'>*</sup></Form.Label> */}
                            <label id="mdltitle"> {labelText}  </label>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form >
                            <Row>
                                <Col xs={6}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label id="idtype">TYPE <sup className='required-mrk'>*</sup></Form.Label>
                                        <Form.Select value={GetList.type} placeholder='select menu' name="type"
                                            {...register("type", {
                                                required: true,
                                            })}
                                            onChange={
                                                (e) => {
                                                    debugger;
                                                    if (labelText == "Add videos") {
                                                        settype(e.target.value)
                                                    }
                                                    else {
                                                        SetList(e.target.value);
                                                        settype(e.target.value)
                                                    }
                                                    //settype(e.target.value)
                                                }}
                                        >
                                            <option value="">select menu</option>
                                            <option value="FRONTEND" >FRONTEND</option>
                                            <option value="BACKEND" >BACKEND</option>
                                        </Form.Select>
                                        {errors.type && errors.Name.type === "required" && (
                                            <p className="errorMsg mt-2">Please select the type</p>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label>NAME<sup className='required-mrk'>*</sup></Form.Label>
                                        <Form.Control
                                            type="text" value={GetList.name}
                                            name="Name" {...register("Name", {
                                                required: true,
                                            })}
                                            onChange={(e) => {
                                                if (labelText == "Add videos") {
                                                    setName(e.target.value)
                                                }
                                                else {
                                                    SetList(e.target.value)
                                                    setName(e.target.value)
                                                }
                                            }}
                                            placeholder="Enter Name"
                                            autoFocus
                                        />
                                        {errors.Name && errors.Name.type === "required" && (
                                            <p className="errorMsg mt-2">Please Enter the Name</p>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>CATEGIORY<sup className='required-mrk'>*</sup></Form.Label>
                                        <Form.Select value={GetList.categiory}
                                            name="categiory" {...register("categiory", {
                                                required: true,
                                            })}

                                            onChange={(e) => {
                                                if (labelText == "Add videos") {
                                                    setcategiory(e.target.value)
                                                }
                                                else {
                                                    SetList(e.target.value)
                                                    setcategiory(e.target.value)
                                                }
                                            }}
                                        >
                                            <option value="">select menu</option>
                                            <option value="TRANSACTION"> Transaction</option>
                                            <option value="CUSTOMER"> Customer</option>
                                            <option value="WAREHOUSE">Warehouse</option>
                                            <option value="RATES">Rates</option>
                                            <option value="SUPPORT">Support</option>
                                            <option value="MASTER">Master</option>
                                            <option value="ORDERS">orders</option>
                                            <option value="SETTINGS">Settings</option>
                                            <option value="SUBSCRIPTION">SubScription</option>
                                            <option value="BARCODE SCAN">Barcode Scan</option>
                                            <option value="STATISTICS">Statistics</option>
                                            <option value="REPORTS">Reports</option>
                                            {/* <option value="INVENTORY PRE-ALERTS">INVENTORY PRE-ALERTS</option> */}
                                            <option value="READY TO SHIP">READY TO SHIP</option>
                                            <option value="SHIPMENT HISTORY">SHIPMENT HISTORY</option>
                                            <option value="PROJECT REQUEST FORM">PROJECT REQUEST FORM</option>
                                            <option value="SHIPMENT">Shipment</option>
                                            <option value="SECURITY">SECURITY</option>
                                            <option value="PICKUPORDER">PICKUPORDER</option>
                                            <option value="QUOTATION">QUOTATION</option>
                                            <option value="GLOBAL SEARCH">GLOBAL SEARCH</option>
                                            <option value="LANGUAGE FLAG">LANGUAGE FLAG</option>
                                            <option value="TASK CONVERTION">TASK CONVERTION</option>
                                            <option value="ACCOUNT SUMMARY">ACCOUNT SUMMARY</option>
                                            <option value="PROFILE PICTURE">PROFILE PICTURE</option>
                                            <option value="TICKETS">TICKETS</option>
                                            <option value="ALERTS">ALERTS</option>QUICK ACTIONS
                                            <option value="QUICK ACTIONS">QUICK ACTIONS</option>
                                            <option value="MY ACCOUNT">MY ACCOUNT</option>
                                        </Form.Select>
                                        {errors.categiory && errors.categiory.type === "required" && (
                                            <p className="errorMsg mt-2">Please select the categiory</p>
                                        )}

                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>PATH<sup className='required-mrk'>*</sup></Form.Label>
                                        <Form.Control
                                            type="text" value={GetList.path}
                                            name="path" {...register("path", {
                                                required: true,
                                            })}
                                            onChange={(e) => {
                                                if (labelText == "Add videos") {
                                                    setpath(e.target.value)
                                                }
                                                else {
                                                    SetList(e.target.value)
                                                    setpath(e.target.value)
                                                }
                                            }}
                                            placeholder="Enter path"
                                            autoFocus
                                        />
                                        {errors.path && errors.path.type === "required" && (
                                            <p className="errorMsg mt-2">path is required.</p>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>DESCRIPTION<sup className='required-mrk'>*</sup></Form.Label>
                                <Form.Control
                                    type="text" value={GetList.description} as="textarea" rows={2}
                                    name="Description" {...register("description", {
                                        required: true,
                                    })}
                                    onChange={(e) => {
                                        if (labelText == "Add videos") {
                                            setdescription(e.target.value)
                                        }
                                        else {
                                            SetList(e.target.value)
                                            setdescription(e.target.value)
                                        }
                                    }}
                                    placeholder="Enter Description"
                                    autoFocus
                                />
                                {errors.description && errors.description.type === "required" && (
                                    <p className="errorMsg mt-2">Please enter the description</p>
                                )}
                            </Form.Group>
                        </Form>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onExit={reload} onClick={handleClose}>
                            Close
                        </Button>
                        <Button type="submit" variant="primary" onClick={handleSubmit(onSubmit)} nExit={reload}>
                            submit
                        </Button>
                    </Modal.Footer>
                </Modal>
      <div className="App">
        <DataGrid visible={true}
     
          height={900}
         className={'striped bordered hover mb-5'}
          dataSource={dataSource}
          showBorders={true}
          key={'idk'}
          focusedRowEnabled={true}
          defaultFocusedRowIndex={0}
          allowColumnReordering={true}
          allowColumnResizing={true}
          showColumnLines={true}
          // showPageSizeSelector={true}
          columnAutoWidth={false}
          remoteOperations={false}
          columnHidingEnabled={false}
          rowAlternationEnabled={true}
        >
          <Paging defaultPageSize={10} />
          <Paging enabled={true} />
          <Pager showPageSizeSelector={true} showInfo={true}/>
          <FilterRow visible={true} />
          {<Scrolling mode="virtual" rowRenderingMode="virtual" />}
          {/* <Grouping autoExpandAll={false} />
            <GroupPanel visible={true} /> */}
          <Scrolling columnRenderingMode="virtual" />
          {/* <SearchPanel visible={true}  placeholder="search...." width={300}  /> */}
          {/* <Sorting mode="single" /> */}
          <Scrolling mode="standard" />
          <Column width={70}
            dataField="idk"
            caption={'SNO'}
            Column allowFiltering={false}
          >
            {/* <HeaderFilter groupInterval={10000} /> */}
          </Column>
          <Column width={1140}
            dataField="name"
            caption={'TOPIC'}
          />
          <Column width={70}
            // caption={'Path'}
            cellRender={(data) => {
              return (
                <a href={`${BasePath}/${data.data.path} `} target="_blank" rel="noopener noreferrer">
                  {/* <img src={play} width={50} height={50} /> */}
                  <FaYoutube size={40} />
                </a>
                // <a href={data.data.path}  target="_blank" rel="noopener noreferrer">
                // {/* {data.data.path} */}
                // <FaYoutube  size={40}/>
                // </a>
              );
            }}
          >
          </Column>
          {/* <Column
            dataField="modifiedDate"
              caption={'modifiedDate'}
              Column allowFiltering={false}
            />
            <Column
            dataField="modifiedBy"
              caption={'ModifiedBy'}
            />
            <Column
            dataField="createdDate"
              caption={'CreatedDate'}
              Column allowFiltering={false}
            />
            <Column
            dataField="createdBy"
              caption={'CreatedBy'}
            />
            <Column
             dataField="categiory"
              caption={'Categiory'}
            />  */}
          {/* <Column
            // dataField="type"
            // caption={'Type'}
            
          /> */}
          {/* <Column dataField={'idk'} caption={'Action'} cellRender={(cellData) => {
                        return (
                            <Button variant="primary ms-1 d-flex" type="Edit" onClick={() => onEditing(cellData.data)} size="sm">Edit</Button>

                        );

                    }} /> */}
        </DataGrid>
      
      </div>
    </React.Fragment>
  )

}



